export default "__VITE_ASSET__2a6f299d__"